import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import SiteConfiguration from './SiteConfiguration';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';

export default async function action({ store, intl }) {

  const title = intl?.formatMessage(messages.manageSiteConfig);

  let isAdminAuthenticated, adminPrivileges, adminId;
  isAdminAuthenticated = store?.getState()?.runtime?.isAdminAuthenticated;
  adminPrivileges = store?.getState()?.adminPrevileges?.privileges?.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  if (!restrictUrls('/siteadmin/settings/config', adminPrivileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: <AdminLayout><SiteConfiguration title={title} /></AdminLayout>,
  };
}
